import {IconRefresh} from '@tabler/icons-react';
import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Refresh" button — thin `Button` wrapper with a refresh icon,
 * `variant="subtle"`, `color="gray"`, defaulting its label to "Refresh".
 * @registry Secondary "reload data" action button.
 *
 * Ported from `library-m/components/buttons/RefreshButton`. Prop surface
 * kept identical (all `Button` props pass through, `children` defaults to
 * "Refresh" but can still be overridden).
 */
export type RefreshButtonProps = ButtonProps;

export const RefreshButton = ({
  variant = 'subtle',
  color = 'gray',
  leftSection = <IconRefresh />,
  children = 'Refresh',
  ...props
}: RefreshButtonProps) => (
  <Button variant={variant} color={color} leftSection={leftSection} {...props}>
    {children}
  </Button>
);
